import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, X, Search } from "lucide-react";
import Swal from "sweetalert2";
import config from "../config";
import { ArrowLeft } from "lucide-react";

export default function IssueTypePage({ handlePageChange }) {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [showModal, setShowModal] = useState(false);

    const [form, setForm] = useState({
        id: null,
        issueName: "",
        description: "",
        color: "#ffffff",
    });

    const API = `${config.API_BASE_URL}/IssueType`;

    // ===== GET =====
    const loadData = async () => {
        const res = await fetch(API);
        const json = await res.json();
        setData(json);
    };

    useEffect(() => {
        loadData();
    }, []);

    // ===== SAVE (POST / PUT) =====
    const save = async () => {
        const isUpdate = !!form.id;

        // ❗ wag isama ang id sa body
        const payload = {
            issueName: form.issueName,
            description: form.description,
            color: form.color,
        };

        try {
            await fetch(isUpdate ? `${API}/${form.id}` : API, {
                method: isUpdate ? "PUT" : "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            Swal.fire({
                icon: "success",
                title: isUpdate ? "Updated!" : "Created!",
                text: "Issue type saved successfully",
                timer: 1500,
                showConfirmButton: false,
            });

            closeModal();
            loadData();
        } catch (err) {
            Swal.fire("Error", "Something went wrong", "error");
        }
    };

    // ===== DELETE =====
    const remove = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the issue type",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dc2626",
            confirmButtonText: "Delete",
        });

        if (!result.isConfirmed) return;

        await fetch(`${API}/${id}`, { method: "DELETE" });

        Swal.fire({
            icon: "success",
            title: "Deleted!",
            timer: 1200,
            showConfirmButton: false,
        });

        loadData();
    };

    const openCreate = () => {
        setForm({ id: null, issueName: "", description: "", color: "#ffffff" });
        setShowModal(true);
    };

    const openEdit = (item) => {
        setForm(item);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setForm({ id: null, issueName: "", description: "", color: "#ffffff" });
    };

    // ===== SEARCH =====
    const filteredData = data.filter(
        (x) =>
            x.issueName.toLowerCase().includes(search.toLowerCase()) ||
            x.description.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="min-h-screen bg-slate-900 text-slate-200 p-8">
            {/* HEADER */}
            {/* HEADER */}
            <div className="flex justify-between items-center mb-6">
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => handlePageChange("maintenance")}
                        className="p-2 rounded-lg bg-slate-800 hover:bg-slate-700"
                    >
                        <ArrowLeft size={20} />
                    </button>


                    <h1 className="text-2xl font-semibold">
                        IssueType Management
                    </h1>
                </div>

                <button
                    onClick={openCreate}
                    className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 px-4 py-2 rounded-lg"
                >
                    <Plus size={18} />
                    Create
                </button>
            </div>


            {/* SEARCH */}
            <div className="mb-4 relative w-72">
                <Search className="absolute left-3 top-2.5 text-slate-400" size={18} />
                <input
                    className="w-full pl-10 pr-3 py-2 bg-slate-800 border border-slate-700 rounded-lg"
                    placeholder="Search issue type..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            {/* TABLE */}
            <div className="overflow-hidden rounded-xl border border-slate-700">
                <table className="w-full text-sm">
                    <thead className="bg-slate-800 text-slate-400">
                        <tr>
                            <th className="text-left p-3">Issue Name</th>
                            <th className="text-left p-3">Description</th>
                            <th className="text-left p-3">Color</th>
                            <th className="text-center p-3">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredData.map((item) => (
                            <tr
                                key={item.id}
                                className="border-t border-slate-700 hover:bg-slate-800"
                            >
                                <td className="p-3">{item.issueName}</td>
                                <td className="p-3">{item.description}</td>
                                <td className="p-3 flex items-center gap-2">
                                    <span
                                        className="w-4 h-4 rounded-full"
                                        style={{ background: item.color }}
                                    />
                                    {item.color}
                                </td>

                                {/* 🔥 ICONS LEFT / RIGHT */}
                                <td className="p-3">
                                    <div className="flex justify-between px-4">
                                        {/* <button
                      onClick={() => openEdit(item)}
                      className="text-yellow-400 hover:text-yellow-300"
                    >
                      <Pencil size={18} />
                    </button> */}

                                        <button
                                            onClick={() => remove(item.id)}
                                            className="text-red-500 hover:text-red-400"
                                        >
                                            <Trash2 size={18} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}

                        {filteredData.length === 0 && (
                            <tr>
                                <td colSpan="4" className="text-center p-6 text-slate-400">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* MODAL */}
            {showModal && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-slate-800 rounded-xl w-full max-w-lg p-6 relative">
                        <button
                            onClick={closeModal}
                            className="absolute right-4 top-4 text-slate-400 hover:text-white"
                        >
                            <X />
                        </button>

                        <h2 className="text-xl font-semibold mb-4">
                            {form.id ? "Update Issue Type" : "Create Issue Type"}
                        </h2>

                        <div className="space-y-4">
                            <input
                                className="w-full bg-slate-900 border border-slate-700 rounded px-3 py-2"
                                placeholder="Issue Name"
                                value={form.issueName}
                                onChange={(e) =>
                                    setForm({ ...form, issueName: e.target.value })
                                }
                            />

                            <textarea
                                className="w-full bg-slate-900 border border-slate-700 rounded px-3 py-2"
                                placeholder="Description"
                                rows="3"
                                value={form.description}
                                onChange={(e) =>
                                    setForm({ ...form, description: e.target.value })
                                }
                            />

                            <div className="flex items-center gap-3">
                                <span className="text-sm text-slate-400">Color</span>
                                <input
                                    type="color"
                                    value={form.color}
                                    onChange={(e) =>
                                        setForm({ ...form, color: e.target.value })
                                    }
                                    className="h-10 w-16 rounded"
                                />
                            </div>

                            <div className="flex justify-end gap-3 pt-4">
                                <button
                                    onClick={closeModal}
                                    className="px-4 py-2 rounded bg-slate-700 hover:bg-slate-600"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={save}
                                    className="px-5 py-2 rounded bg-blue-600 hover:bg-blue-500"
                                >
                                    {form.id ? "Update" : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
